export default "__VITE_ASSET__Davf_2I$__"